import React from "react";
import CEHomeWidgetDHE from "../CEHomeWidgetDHE";
import CEHomeWidgetDMP from "../CEHomeWidgetDMP";

import { useConfig } from "@eis-poc/lib-discover-medical-mfes";
import { PRODUCT_CODE } from "../../constants/productCodes";

function CEHomeWidget() {
  const configData = useConfig();
  const productCode = configData?.productInfo.productCode;

  const getWidget = () => {
    switch (productCode) {
      case PRODUCT_CODE.DHE:
        return <CEHomeWidgetDHE />;

      case PRODUCT_CODE.DMP:
      case PRODUCT_CODE.DMX:
        return <CEHomeWidgetDMP />;

      default:
        return null;
    }
  };

  return <>{getWidget()}</>;
}

export default CEHomeWidget;
